import { platformProviderValue, PLATFORM_PROVIDER_VALUE_OPTIONS_DEFAULT } from "./platform-provider-value";
export function platformQueryValue(data, path, defaultValue, options) {
  if (data === void 0) {
    data = {};
  }

  if (path === void 0) {
    path = '';
  }

  if (defaultValue === void 0) {
    defaultValue = {};
  }

  if (options === void 0) {
    options = PLATFORM_PROVIDER_VALUE_OPTIONS_DEFAULT;
  }

  return platformProviderValue(data, path, defaultValue, options);
}